import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import EditFieldSidebar from "./EditFieldSidebar";
import DragFieldSidebar from "./DragFieldSidebar";

const Sidebar = ({ isEditing }) => {
	return <>{isEditing ? <EditFieldSidebar /> : <DragFieldSidebar />}</>;
};

Sidebar.propTypes = {
	isEditing: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
	return {
		isEditing: state.form.isEditing,
	};
};

export default connect(mapStateToProps, null)(Sidebar);
